
import { defineComponent, ref, onBeforeUnmount, Ref } from 'vue'
import AppHeader from '@/components/Header.vue'
import { ImagePreview, Toast } from 'vant'
import uploadFilesSetup from '@/compositions/uploadFiles'
import getRoute from '@/compositions/route'
import { getServiceDetail } from '@/apis/fault'
import { ComponentInstance } from 'vant/lib/utils'
// import { ImageInfo, UploadFile } from '@/types/public'

export default defineComponent({
  name: 'Fault-Content',
  components: {
    AppHeader,
  },
  setup() {
    const { params } = getRoute()
    const { getFiles } = uploadFilesSetup()
    const imgs: Ref<string[]> = ref([])
    let _ts: number = Date.now()
    const describe: Ref<string> = ref('')
    const cacheNetworkpointName: Ref<string> = ref('')
    let toast: ComponentInstance = null
    const getData = async () => {
      const ts: number = _ts
      toast = Toast({
        type: 'loading',
        message: '加载中...',
        forbidClick: true,
        duration: 0,
      })
      try {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const result: any = await getServiceDetail((params.value?.guid as string) || '')
        if (ts !== _ts) return
        const { description, repair_warehouse, images } = result
        describe.value = description || ''
        cacheNetworkpointName.value = repair_warehouse?.name || ''
        if (images?.length) {
          getFiles([], images)
            .then((res) => {
              if (ts !== _ts) return
              if (res?.fileObjArr?.length) {
                imgs.value = res.fileObjArr.map((it) => it.url)
              }
            })
            .catch((err: unknown) => {
              if (ts !== _ts) return
              const message: string = (err as { message: string }).message
              console.error(message)
            })
            .finally(() => {
              toast.clear()
            })
        }
        toast.clear();
      } catch (err: unknown) {
        if (ts !== _ts) return
        toast.clear()
        const message: string = (err as { message: string }).message
        Toast(message)
        console.error(message)
      }
    }
    getData()
    onBeforeUnmount(() => {
      if (toast) {
        toast.clear()
        toast = null
      }
      _ts = 0
    })
    return {
      imgs,
      describe,
      cacheNetworkpointName,
    }
  },
  methods: {
    getBigImages(i: number): void {
      ImagePreview({
        images: this.imgs,
        startPosition: i,
      })
    },
  },
})
